export const getDetailedBid = (state: any) => {
	return state?.common?.detailsBid && state?.common?.detailsBid !== 'NOT_FOUND' ? state?.common?.detailsBid : null;
};
